import { Component, Inject, OnInit } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http'
import { environment } from 'src/environments/environment'
import { ActivatedRoute, Router } from '@angular/router';
import { GeolocationService } from '../services/geolocationservice';
import { sweetalert } from "../services/sweetalert";
import { DOCUMENT } from '@angular/common';
import { DatePipe } from '@angular/common';
import { SmartechService } from '../services/smartech.service';

@Component({
  selector: 'app-shop-online-brands',
  templateUrl: './shop-online-brands.component.html',
  styleUrls: ['./shop-online-brands.component.css']
})
export class ShopOnlineBrandsComponent implements OnInit {


  response: any;
  custid: any;
  mobile: any;
  loader: boolean;
  responseData: any;
  filtersLoaded: Promise<boolean>;
  reDirUrl: any;
  port: any;
  reqData: any;
  brandName: any;
  brandUrl: any;
  electronicList = [];
  list = [];
  flipKart: any;
  travelList: any;
  educationList: any;
  customer_id: any;
  mobile_no: any;
  lat: any;
  lng: any;
  selectedCategory: any;
  selectedCategoryList: any;
  brandList = [];
  bannerList: any;
  mainList = [];

  selectedTabData: any;
  searchText: string;
  dataTobeDisplay: any[];
  helperList: any;
  selectedHelperData: any;
  helperObj: any;
  url_p: any;
  decryptData: any;
  currentTime: string = '';
  constructor(private service: GeolocationService,
    private activatedRoute: ActivatedRoute,
    private alert: sweetalert,
    private httpClient: HttpClient,
    private router: Router,
    private datePipe: DatePipe,
    private smartechService: SmartechService,
    @Inject(DOCUMENT) private document: any) {//this.preloadImages(); 

  }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe(params => {

      this.reqData = params['data'] ? params['data'] : null;
      this.lat = params["lat"] != null ? params["lat"] : null;
      this.lng = params["lng"] != null ? params["lng"] : null;

      // console.log('lat:' + this.lat);
      console.log('abc:' + this.reqData);
      //alert("abc"+this.reqData);
      if (typeof this.reqData !== 'object' && this.reqData !== null && this.reqData.includes('{') && this.reqData.includes('}')) {
        this.reqData = JSON.parse(this.reqData);
        this.customer_id = this.reqData.customer_id;
        this.mobile_no = this.reqData.mobile_no;
      }
      if (this.reqData != null) {
        this.getData(this.reqData);
      }
      else {
        this.loadPage();
        // if((environment.baseUrl).includes('http://localhost:')){
        //   this.url_p='http://localhost'+`:${window.location.port}`+'/shop-online-home';
        // }
        // else{
        //   this.url_p=environment.baseUrl+'/shop-online-home'
        // }
        // let obj = {
        //   url: this.url_p
        // }
        // console.log("obj"+obj);
        // this.httpClient
        // .post(environment.baseUrl + '/tvsm/saveShopOnlineLogs', obj)
        // .toPromise().then(data => {
        //   console.log("data", data);
        // });
      }
      console.log('reqData:' + JSON.stringify(this.reqData));

      error => {

        console.error("Unable to Process")

      }
    });



    this.service.getshopOnlineBanner().subscribe((data: any) => {
      this.bannerList = JSON.parse(data.data);
      this.bannerList.sort((a, b) => a.BANNER_ORDER - b.BANNER_ORDER)
      console.log("banner", this.bannerList);

    });


  }
  loadPage() {
    this.service.getOnlineShopUrl().subscribe((data: any) => {
      if (typeof (data) === 'object') {
        console.log("event:" + JSON.stringify(data));
        this.response = JSON.parse(data.data);

        this.mainList = this.response.MAIN_LIST;
        this.brandList = this.response.MERCHANTS_LIST;
        this.helperList = this.response.HELPER_LIST;
        this.brandList.sort((a, b) => a.BRAND_CATEGORY_ORDER - b.BRAND_CATEGORY_ORDER || a.BRAND_ORDER - b.BRAND_ORDER);
        this.mainList.sort((a, b) => a.CATEGORY_ORDER - b.CATEGORY_ORDER);

        //this.selectedCategory=this.mainList[0].CATEGORY_NAME;
        //this.selectedCategoryList=this.getSelectedCategoryList(this.selectedCategory);
        this.dataTobeDisplay = this.brandList;

        if (data.statusCode == 'EX') {

          //this.loader = false;

        } else if (data.statusCode == 'SR') {
          // this.loader = false;
        }

      }


    });
  }
  redirectUrl(data: any) {
    let obj = {
      custid: `${this.customer_id}`,
      mobile: `${this.mobile_no}`,
      brandname: `${data.BRAND_NAME}`,
      lat: `${this.lat}`,
      lng: `${this.lng}`
    }

    if (obj.custid && obj.mobile && obj.lat && obj.lng) {

      this.httpClient
        .post(environment.baseUrl + '/tvsm/saveShopOnlineLogs', obj)
        .toPromise().then(data => {
          console.log("data", data);
        });

    }
    if (data.BRAND_NAME == 'flipkart' || data.BRAND_NAME == 'Amazon') {
      const now = new Date();
      this.currentTime = this.datePipe.transform(now, 'dd-MM-yyyy hh:mm a') || '';

      this.smartechService.trackProductClick(data.BRAND_NAME, "Merchant Click", this.currentTime, this.customer_id, "Shop Online – Ecom PWA", this.mobile_no);
    }
    if (data.BRAND_NAME == 'flipkart' || data.BRAND_NAME == 'Amazon') {
      this.selectedHelperData = this.helperList.filter(s => s.BRAND_NAME === data.BRAND_NAME);
      this.helperObj = this.selectedHelperData[0];
      console.log("this.helperObj:" + JSON.stringify(this.helperObj));
      // localStorage.setItem('helperData', JSON.stringify(this.helperObj));
      // localStorage.setItem('brandUrlForHelper',data.BRAND_URL);
      sessionStorage.setItem('helperData', JSON.stringify(this.helperObj));
      sessionStorage.setItem('brandUrlForHelper', data.BRAND_URL);
      this.router.navigate(["helper-screen"]);
    }
    else {
      window.location.href = data.BRAND_URL;
    }
  }

  getSelectedCategoryList(category: string) {
    this.searchText = "";
    this.selectedCategory = category;
    this.selectedCategoryList = this.mainList.filter(
      (e: { CATEGORY_NAME: string }) => e.CATEGORY_NAME == category
    );

    this.brandList = this.selectedCategoryList[0].BRAND_LIST;
    this.brandList.sort((a, b) => a.BRAND_ORDER - b.BRAND_ORDER);
    this.dataTobeDisplay = this.brandList;

  }

  onSearchKeyUp() {
    console.log("this.brandList" + JSON.stringify(this.brandList));
    console.log(this.searchText);

    let searchData = this.brandList.filter((e: any) => {
      let name = e.BRAND_NAME.toLowerCase();
      return name.includes(this.searchText?.toLowerCase())
        ? name.includes(this.searchText.toLowerCase())
        : undefined;

    });
    console.log("searchData" + searchData);
    searchData
      ? (this.dataTobeDisplay = searchData)
      : (this.dataTobeDisplay = this.brandList);
  }

  getData(reqData: any) {
    if (typeof (reqData) != 'object') {
      this.service.getDecryptData(reqData).subscribe((data: any) => {
        if (typeof (data) === 'object') {
          //alert(JSON.stringify(data));
          console.log("event:" + JSON.stringify(data));
          if (data.statusCode == 'EX') {

            this.alert.errorsweertalert(data.statusMessage);

          } else if (data.statusCode == 'SR') {
            this.decryptData = data.data;
            this.customer_id = this.decryptData.customerId;
            this.mobile_no = this.decryptData.mobileNo;
            this.getUrlData();

          }

        }


      });
    }
    else {
      this.getUrlData();
    }

  }
  getUrlData() {
    if (this.reqData != null) {
      let reqObject: any;
      //this.reqData = JSON.parse(this.reqData);
      if (typeof (this.reqData) === 'object') {
        reqObject = {
          customer_id: `${this.reqData.customer_id}`,
          mobile_no: `${this.reqData.mobile_no}`,
          redirURL: `${this.reqData.redirURL}`,
          system: `${this.reqData.system}`,
          lat: `${this.lat}`,
          lng: `${this.lng}`
        }

      }
      else {
        reqObject = {
          customer_id: `${this.decryptData.customerId}`,
          mobile_no: `${this.decryptData.mobileNo}`,
          redirURL: `${this.decryptData.redirURL}`,
          system: `${this.decryptData.system}`,
          lat: `${this.lat}`,
          lng: `${this.lng}`,
          mfiEncData: `${this.decryptData.mfiEncData}`,
          encryptData: `${this.reqData}`
        }
      }



      this.service.getUrl(reqObject).subscribe(
        (data: any) => {

          this.loader = true;
          if (typeof (data) === 'object') {
            this.responseData = JSON.parse(data.data);
            console.log("response:" + JSON.stringify(this.responseData))
            if (this.responseData.STATUS_CODE == 'ER') {
              this.alert.errorsweertalert(this.responseData.STATUS_MESSAGE);
              // setTimeout(() => {
              //   window.location.href = this.responseData.URL;
              // }, 3000);

            }
            else if (this.responseData.STATUS_CODE == 'SR' && (this.responseData.MFI_ELIGIBLE == 'N') && this.responseData.SYSTEM == 'SO') {
              this.loadPage();
              this.filtersLoaded = Promise.resolve(true);
              this.loader = false;
            }
            else if (this.responseData.STATUS_CODE == 'SR' && (this.responseData.MFI_ELIGIBLE == 'Y' || this.responseData.MFI_ELIGIBLE == 'N')) {
              window.location.href = this.responseData.URL;
            }
            else {
              this.loadPage();
              this.filtersLoaded = Promise.resolve(true);
              this.alert.errorsweertalert("Something went wrong");
              this.loader = false;
            }

          }
          this.loader = false;
        }
      );
    }
    else {
      this.loadPage();
      this.filtersLoaded = Promise.resolve(true);
    }
  }

  goBack() {
    this.router.navigate(["shop-online-home"]);
  }
}

